import { render, staticRenderFns } from "./FootPage.vue?vue&type=template&id=e8034f36&scoped=true&"
import script from "./FootPage.vue?vue&type=script&lang=js&"
export * from "./FootPage.vue?vue&type=script&lang=js&"
import style0 from "./FootPage.vue?vue&type=style&index=0&id=e8034f36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8034f36",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
